import { Input, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const Wrapper = styled.div`
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const Table = styled.table`
  border-spacing: 0;
  width: 100%;
`;

const TableWrapper = styled.div`
  flex: 1;
  overflow-x: auto;
  width: 100%;
`;

const EmptyTableTitle = styled(Typography)`
  margin-bottom: 8px;
`;

const EmptyTableDescription = styled(Typography)`
  margin-bottom: 40px;
  text-align: center;
  width: 400px;
`;

const EmptyTableDefaultWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 80px 0;
`;

const EmptyTableWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
  justify-content: center;
  margin: 80px 0;
`;

const EmptyTableText = styled(Typography)`
  margin-top: 16px;
`;

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const HeadCheckbox = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const HeadSelectedItems = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  font-weight: 700;
  gap: 4px;
`;

const HeadSelected = styled.td`
  align-items: center;
  background-color: var(--color-accent-primary-weakest);
  color: var(--color-fg-default);
  display: flex;
  flex-direction: row;
  height: 48px;
  padding: 0 16px;
  position: absolute;
  text-transform: none;
  top: 0;
  width: 100%;
`;

const TableSectionHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--size-8);
  max-width: 1140px;

  ${Input.S.Input} {
    min-width: 300px;
  }
`;

const SectionHeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--size-gap-8);
`;

const SectionHeaderRight = styled.div`
  display: flex;
  flex-direction: row;
`;

export {
  EmptyTableDefaultWrapper,
  EmptyTableDescription,
  EmptyTableText,
  EmptyTableTitle,
  EmptyTableWrapper,
  HeadCheckbox,
  HeadSelected,
  HeadSelectedItems,
  RightColumn,
  SectionHeaderLeft,
  SectionHeaderRight,
  Table,
  TableSectionHeader,
  TableWrapper,
  Wrapper
};
